import React from 'react'
import style from '../card.module.css'
function Reson() {
  return (
    <div className={style.syllabus_card}>
    <div>    
        <h3>Reasoning</h3>  
        <p>1 upcoming . 86 courses</p>      
    </div>   
    
        <p>Verbal Resoning, Airthmetic </p>      
        
    </div>
  )
}
export default Reson;